export default __webpack_public_path__ + "static/media/dropdownArrow.4d5a885d.svg";